import { useClickToCall } from "@/hooks/useClickToCall";
import { faCopy, faPhone } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import classNames from "classnames";
import { FC } from "react";
import { toast } from "react-toastify";

interface IProps {
  number: string;
  className?: string;
}

/**
 * A phone number with a click-to-call trigger and a copy button, kept as two
 * separate controls flanking the number itself — the number is plain text
 * (selectable/copyable by drag-select), not the button, since wrapping the
 * whole number in a <button> (the previous design) made it unselectable in
 * every browser.
 */
const PhoneCallLink: FC<IProps> = ({ number, className }) => {
  const onCall = useClickToCall();

  const onCopy = () => {
    navigator.clipboard.writeText(number).then(
      () => toast.success("Numéro copié"),
      () => toast.error("Impossible de copier le numéro")
    );
  };

  return (
    <span
      className={classNames(
        "d-inline-flex align-items-center gap-1",
        className ?? "fs--1"
      )}
    >
      <button
        type="button"
        className="btn btn-link p-0 text-body-secondary"
        aria-label={`Appeler ${number}`}
        title="Appeler"
        onClick={() => onCall(number)}
      >
        <FontAwesomeIcon icon={faPhone} transform="shrink-4" />
      </button>
      <span className="user-select-all">{number}</span>
      <button
        type="button"
        className="btn btn-link p-0 text-body-tertiary"
        aria-label={`Copier le numéro ${number}`}
        title="Copier le numéro"
        onClick={onCopy}
      >
        <FontAwesomeIcon icon={faCopy} transform="shrink-4" />
      </button>
    </span>
  );
};

export default PhoneCallLink;
